'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _customHeader = require('../../custom-header');

var _customHeader2 = _interopRequireDefault(_customHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JobsHeader = function (_React$Component) {
  _inherits(JobsHeader, _React$Component);

  function JobsHeader() {
    _classCallCheck(this, JobsHeader);

    return _possibleConstructorReturn(this, (JobsHeader.__proto__ || Object.getPrototypeOf(JobsHeader)).apply(this, arguments));
  }

  _createClass(JobsHeader, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_customHeader2.default, _extends({ className: 'pp-header--jobs' }, this.props));
    }
  }]);

  return JobsHeader;
}(_react2.default.Component);

exports.default = JobsHeader;


JobsHeader.defaultProps = {
  config: {
    useMinimalHeader: false
  },
  content: {
    minimalHeader: {
      labelMenuButton: 'Menu',
      labelClose: 'Close',
      logo: {
        text: 'PayPal',
        href: '/webapps/mpp/jobs',
        subText: 'PayPal Jobs'
      }
    },
    mainMenuContent: [{
      type: 'linkOnly',
      text: 'Culture',
      href: '/webapps/mpp/jobs/culture'
    }, {
      type: 'linkOnly',
      text: 'Benefits',
      href: '/webapps/mpp/jobs/benefits'
    }, {
      type: 'linkOnly',
      text: 'People',
      href: '/webapps/mpp/jobs/people'
    }, {
      type: 'linkOnly',
      text: 'Students & Grads',
      href: '/webapps/mpp/jobs/students-and-grads'
    }, {
      type: 'linkOnly',
      text: 'Categories',
      href: '/webapps/mpp/jobs/jobs-by-category'
    }, {
      type: 'linkOnly',
      text: 'Locations',
      href: '/webapps/mpp/jobs/locations'
    }, {
      type: 'linkOnly',
      text: 'Companies',
      href: '/webapps/mpp/jobs/companies'
    }, {
      type: 'linkOnly',
      text: 'My Profile',
      href: 'https://wd1.myworkdaysite.com/en-US/recruiting/paypal/jobs/login'
    }],
    sublistMobile: []
  }
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/jobs-header/jsx/JobsHeader.js
// module id = 1111
// module chunks = 4